export default __webpack_public_path__ + "img/cmWCAfoy.d0b40351.svg";